import { Grid } from '@mui/material';
import { CountryFieldProps } from '../fields/country-field/country-field.component';
import { RegionFieldProps } from '../fields/region-field/region-field.component';
import AddressFormProvider from './address-form.context';
import { UsePlaceOptions } from './address-form.hooks';
import CityField from './fields/city-field/city-field.component';
import CountryField from './fields/country-field/country-field.component';
import LatitudeField from './fields/latitude-field/latitude-field.component';
import LongitudeField from './fields/longitude-field/longitude-field.component';
import PostalCodeField from './fields/postal-code-field/postal-code-field.component';
import RegionField from './fields/region-field/region-field.component';
import StreetAddress1Field, {
  StreetAddress1Props,
} from './fields/street-address-1-field/street-address-1-field.component';
import StreetAddress2Field from './fields/street-address-2-field/street-address-2-field.component';

export type AddressFieldNames = {
  streetAddress1: string;
  streetAddress2: string;
  city: string;
  region: string;
  postalCode: string;
  country: string;
  latitude?: string;
  longitude?: string;
};

export type AddressFormType = {
  fieldNames?: AddressFieldNames;
  usePlaceOptions?: UsePlaceOptions;
  countryIdKey?: CountryFieldProps['idKey'];
  regionIdKey?: RegionFieldProps['idKey'];
  streetAddress1Props?: StreetAddress1Props;
  compact?: boolean;
};

const AddressForm = ({
  fieldNames = {
    streetAddress1: 'address.streetAddress1',
    streetAddress2: 'address.streetAddress2',
    city: 'address.city',
    region: 'address.region',
    postalCode: 'address.postalCode',
    country: 'address.country',
    latitude: 'latitude',
    longitude: 'longitude',
  },
  usePlaceOptions,
  countryIdKey,
  regionIdKey,
  streetAddress1Props,
  compact,
}: AddressFormType) => {
  return (
    <AddressFormProvider
      fieldNames={fieldNames}
      usePlaceOptions={usePlaceOptions}
    >
      <StreetAddress1Field
        name={fieldNames.streetAddress1}
        {...streetAddress1Props}
      />
      <StreetAddress2Field name={fieldNames.streetAddress2} />
      <Grid container columnSpacing={2}>
        <Grid size={{ xs: 12, sm: 12, md: compact ? 12 : 6 }}>
          <CityField name={fieldNames.city} />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: compact ? 12 : 3 }}>
          <RegionField
            name={fieldNames.region}
            idKey={regionIdKey}
            countryIdKey={countryIdKey}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: compact ? 12 : 3 }}>
          <PostalCodeField name={fieldNames.postalCode} />
        </Grid>
      </Grid>
      <CountryField name={fieldNames.country} idKey={countryIdKey} />

      {fieldNames.latitude && fieldNames.longitude && (
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, sm: 12, md: compact ? 12 : 6 }}>
            <LatitudeField name={fieldNames.latitude} />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: compact ? 12 : 6 }}>
            <LongitudeField name={fieldNames.longitude} />
          </Grid>
        </Grid>
      )}
    </AddressFormProvider>
  );
};
export default AddressForm;
